import React, { useEffect, useState, useRef } from "react";
import * as Utils from '../../commons/utils/Utils';
import {
    TableRow,
} from '@material-ui/core';
import 'moment/min/locales';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import Loading from '../ui/Loading.js';
import moment from 'moment';
import Security from '../../commons/security/Security.js';
import swal2 from 'sweetalert2';
import { useIntl } from "react-intl";
import Timezone from "../../commons/timezone/Timezone.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DisponibilidadGridRow = ({movil, comboMotivos, onActualizarMotivo, loading, columnsEnabled}) => {
  const intl = useIntl()
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const refDropdown = useRef(null);

  const calculateOciosidad = () => {
    if (!movil.fechaHoraInicioOciosidad) return '';
    const fechaInicio = moment(movil.fechaHoraInicioOciosidad);
    if (!fechaInicio.isValid()) return '';
    const fechaFin = movil.fechaHoraFinOciosidad ? moment(movil.fechaHoraFinOciosidad) : moment();
    if (!fechaFin.isValid()) return '';
    
    const diffInMinutes = fechaFin.diff(fechaInicio, 'minutes');
    const totalHours = Math.floor(diffInMinutes / 60);
    const minutes = diffInMinutes % 60;

    let months = 0, days = 0, hours = 0;
    if (totalHours >= 24) {
      days = Math.floor(totalHours / 24);
      hours = totalHours % 24;
      if (days >= 30) {
        months = Math.floor(days / 30);
        days = days % 30;
      }
    } else {
      hours = totalHours;
    }

    let partes = [];
    if (months > 0) partes.push(`${months}M`);
    if (days > 0) partes.push(`${days}D`);
    if (hours > 0 || (months === 0 && days === 0)) partes.push(`${hours}h`);
    if (minutes > 0) partes.push(`${minutes}m`);
    return partes.join(' ');
  };

  const tiempoOciosidad = calculateOciosidad();

  const formatFechaInicioOciosidad = () => {
    return moment(movil.fechaHoraInicioOciosidad).format('DD/MM/YYYY HH:mm');
  };

  const fechaInicioOciosidadFormateada = formatFechaInicioOciosidad();

  const [fechaRetorno, setFechaRetorno] = useState(
    movil.fecha_retorno ? moment(movil.fecha_retorno) : null
  );

  const handleFechaRetornoChange = (date) => {
    setFechaRetorno(date);
    Utils.sendData('/disponibilidad/fecha-retorno', 'PUT', {
      movil_id: movil.id,
      fecha_retorno: date ? date.format('YYYY-MM-DD') : null
    });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setMostrarMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownMotivos = () => {
    const tienePermiso = Security.hasPermission('DISPONIBILIDAD_ASIGNAR_MOTIVOS_HISTORICO');

    return (
      <div className="d-flex align-items-center"
        style={{
          padding: "4px",
          backgroundSize: "auto",
          width: "fit-content"
        }}
      >
        <div>{getNombreMotivo(movil.motivo_id)}</div>
        {tienePermiso &&
          (<div>
            <i
              id="dLabel"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              className="fa fa-chevron-down cursor-pointer"
              style={{ marginRight: "5px", marginLeft: "5px" }}
            ></i>
            <div className="dropdown-menu" aria-labelledby="dLabel">
              <p
                key="ninguno"
                className="dropdown-item"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleChangeMotivo(null, movil.movilHistorialOciosoId);
                }}
              >
                {intl.formatMessage({
                  id: 'disponibilidad_ociosidad_seleccioneMotivo',
                  defaultMessage: 'Seleccione Motivo'
                })
                }
              </p>
              {comboMotivos.length > 0
                && comboMotivos.map((motivo, i) => {
                  return (
                    <p
                      key={i}
                      className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleChangeMotivo(motivo.id, movil.movilHistorialOciosoId);
                      }}
                    >
                      {motivo.nombre}
                    </p>
                  );
                })
              }
            </div>
          </div>)}
      </div>
    )
  }


  const handleChangeMotivo = (motivo_id, movil_historial_ocioso_id) => {
    Utils.sendData(`/motivos/ociosidad`, 'PUT', { motivo_id, movil_historial_ocioso_id })
      .then(({motivo_id, movil_id}) => {
        onActualizarMotivo(motivo_id, movil_id);
        swal2.fire(
          intl.formatMessage({ id: 'El_cambio_fue_guardado_con_Exito!', defaultMessage: 'El cambio fue guardado con Éxito!' }),
          " ",
          'success'
        );
      })
  }

  const getNombreMotivo = (id) => {
    const motivo = comboMotivos.filter(motivo => motivo.id === id);
    return motivo.length > 0 ? motivo[0].nombre : '';
  } 

  return (
    <>
      {loading && <Loading />}
      <TableRow>
          <StyledTableCell align="left">
            {movil.dominio}
          </StyledTableCell>
          <StyledTableCell align="left">
            {movil.fecha_actualizacion_motivo && (
              <div className="text-center success dt-info-icon">
                <StyledTooltip
                  title={<div> Ult. actualización Motivo: <br />
                    {Timezone.getDateForClient(movil.fecha_actualizacion_motivo, null, 'YYYY-MM-DD HH:mm')} <br />
                    Usuario:
                    {(movil.usuarioModificacionMotivo ? movil.usuarioModificacionMotivo : "")}
                  </div>}
                  arrow
                  placement="top"
                  >
                  <i className="la la-clock-o"></i>
                </StyledTooltip>
              </div>
            )}
          </StyledTableCell>
          <StyledTableCell align="left">
            {dropdownMotivos()}
          </StyledTableCell>
        <StyledTableCell align="left">
          <DatePicker
            id={`fechaRetorno-${movil.id}`}
            name={`fechaRetorno-${movil.id}`}
            className="form-control date-picker-placeholder"
            placeholderText={intl.formatMessage({ id: 'movilesAbm.render.general_data.placeholder_fecha_de_alta', defaultMessage: 'DD/MM/AAAA' })}
            selected={fechaRetorno}
            onChange={handleFechaRetornoChange}
            minDate={moment()}
            onKeyDown={(e) => e.preventDefault()}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="DD/MM/YYYY"
          />
        </StyledTableCell>
          <StyledTableCell align="left">
            {movil.modelo}
          </StyledTableCell>
          <StyledTableCell align="left">
          {movil.tipoModelo}
          </StyledTableCell>
          <StyledTableCell align="left">
          {movil.base}
          </StyledTableCell>
          <StyledTableCell align="left">
          {movil.subregion}
          </StyledTableCell>
          <StyledTableCell align="left">
          {movil.region}
          </StyledTableCell>
          <StyledTableCell show={columnsEnabled.transportadora} align="left">
          {movil.transportadora}
          </StyledTableCell>
          <StyledTableCell show={columnsEnabled.rentadora} align="left">
            {movil.rentadora}
          </StyledTableCell>
          <StyledTableCell align="left">
          {movil.cecos}
          </StyledTableCell>
        <StyledTableCell show={columnsEnabled.esReservaEnabled} align="left">
          {movil.es_reserva !== null ?
            (movil.es_reserva ?
              intl.formatMessage({ id: 'Si', defaultMessage: 'Si' }) :
              intl.formatMessage({ id: 'No', defaultMessage: 'No' }))
            : null
          }
        </StyledTableCell>
          <StyledTableCell align="left">
          {fechaInicioOciosidadFormateada}
          </StyledTableCell>
          <StyledTableCell align="left">
          {tiempoOciosidad}
          </StyledTableCell>
        </TableRow>
      </>
  )
}

export default DisponibilidadGridRow
